
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import UserIndex from './user';
import SkillIndex from '@dndViews/skill';
import SenseIndex from '@dndViews/sense';
import DeityIndex from '@dndViews/deity';
import UserTicketIndex from '@dndViews/user_ticket';
import TicketIndex from '@dndViews/ticket';
import ErrorLogIndex from '@dndViews/error_log';
import SpellIndex from '@dndViews/spell';
import SpellSlotTypeIndex from '@dndViews/spell_slot_type';
import GameCardIndex from '@dndViews/game_card';
import GameDeckIndex from '@dndViews/game_deck';
import TableIndex from '@dndViews/table';
import ArmorTypeIndex from '@dndViews/armor_type';
import LanguageIndex from '@dndViews/language';
import ReusableStringIndex from '@dndViews/reusable_string';
import GiftIndex from '@dndViews/gift';
import BastionFacilityIndex from '@dndViews/bastion_facility';
import BackgroundIndex from '@dndViews/background';
import ResourceIndex from '@dndViews/resource';
import ItemIndex from '@dndViews/item';
import RollableTableIndex from '@dndViews/rollable_table';
import LootTableIndex from '@dndViews/loot_table';
import CreatureIndex from '@dndViews/creature';
import CreatureGroupIndex from '@dndViews/creature_group';
import CreatureGiftIndex from '@dndViews/creature_gift';
import FeatIndex from '@dndViews/feat';
import EldritchInvocationIndex from '@dndViews/eldritch_invocation';
import FightingStyleIndex from '@dndViews/fighting_style';
import ConditionIndex from '@dndViews/condition';
import PactBoonIndex from '@dndViews/pact_boon';
import GameClassIndex from '@dndViews/game_class';
import SubclassIndex from '@dndViews/subclass';
import EquipmentPackIndex from '@dndViews/equipment_pack';
import MagicItemKeywordIndex from '@dndViews/magic_item_keyword';
import WeaponMasteryPropertyIndex from '@dndViews/weapon_mastery_property';
import RaceIndex from '@dndViews/race';
import SubraceIndex from '@dndViews/subrace';
import SpellListIndex from '@dndViews/spell_list';
import TemplateBaseIndex from '@dndViews/template_base';
import FloatingFeatureIndex from '@dndViews/floating_feature';
import CreatureFeatureIndex from '@dndViews/creature_feature';
import SpecialFeatureIndex from '@dndViews/special_feature';
import ToolIndex from '@dndViews/tool';
import StandardFeaturesIndex from '@dndViews/standard_features';
import SourceBookIndex from '@dndViews/source_book';

export default function StandardIndex() {
  const { data_type } = useParams();
  
  if (data_type) {
    switch (data_type) {
      case "user": return <UserIndex />;
      case "skill": return <SkillIndex />;
      case "sense": return <SenseIndex />;
      case "deity": return <DeityIndex />;
      case "user_ticket": return <UserTicketIndex />;
      case "ticket": return <TicketIndex />;
      case "error_log": return <ErrorLogIndex />;
      case "spell": return <SpellIndex />;
      case "spell_slot_type": return <SpellSlotTypeIndex />;
      case "game_card": return <GameCardIndex />;
      case "game_deck": return <GameDeckIndex />;
      case "table": return <TableIndex />;
      case "armor_type": return <ArmorTypeIndex />;
      case "language": return <LanguageIndex />;
      case "reusable_string": return <ReusableStringIndex />;
      case "gift": return <GiftIndex />
      case "bastion_facility": return <BastionFacilityIndex />;
      case "background": return <BackgroundIndex />;
      case "resource": return <ResourceIndex />;
      case "item": return <ItemIndex />;
      case "rollable_table": return <RollableTableIndex />;
      case "loot_table": return <LootTableIndex />;
      case "creature": return <CreatureIndex />;
      case "creature_group": return <CreatureGroupIndex />;
      case "creature_gift": return <CreatureGiftIndex />;
      case "feat": return <FeatIndex />;
      case "eldritch_invocation": return <EldritchInvocationIndex />;
      case "fighting_style": return <FightingStyleIndex />;
      case "condition": return <ConditionIndex />;
      case "pact_boon": return <PactBoonIndex />;
      case "game_class": return <GameClassIndex />;
      case "subclass": return <SubclassIndex />;
      case "equipment_pack": return <EquipmentPackIndex />;
      case "magic_item_keyword": return <MagicItemKeywordIndex />;
      case "weapon_mastery_property": return <WeaponMasteryPropertyIndex />;
      case "race": return <RaceIndex />;
      case "subrace": return <SubraceIndex />;
      case "spell_list": return <SpellListIndex />;
      case "template_base": return <TemplateBaseIndex />;
      case "floating_feature": return <FloatingFeatureIndex />;
      case "creature_feature": return <CreatureFeatureIndex />;
      case "special_feature": return <SpecialFeatureIndex />;
      case "tool": return <ToolIndex />;
      case "standard_features": return <StandardFeaturesIndex />;
      case "source_book": return <SourceBookIndex />;
    }
  }
  return <>Data Type Not Recognized</>; // I'll make this go to an actual error page later.
}
